export const EQUIPMENT = [
  'barbell',
  'dumbbell',
  'cable',
  'machine',
  'bodyweight',
  'kettlebell',
  'band',
  'smith',
  'other',
] as const;

export type Equipment = (typeof EQUIPMENT)[number];
